<template>
  <div class="max-w-full overflow-hidden">
    <div class="trending-posts-list">
      <TrendingItem
        v-for="(post, index) in posts"
        :key="post.id"
        :post="post"
        :postIndex="index"
      />
    </div>
  </div>
</template>
<script>
import TrendingItem from "@/templates/post-list/TrendingItem.vue";

export default {
  name: "TrendingPostsList",
  props: {
    posts: Array,
  },
  components: { TrendingItem },
};
</script>
<style>
.trending-posts-list article.trending {
  @apply w-full mb-10 flex;
}
.trending-posts-list .index {
  @apply text-yka-blue text-center text-4xl w-10 relative mr-4 opacity-50;
}
.trending-posts-list .author-name {
  @apply font-normal;
}
.trending-posts-list .title {
  @apply text-lg font-bold text-black tracking-tight leading-tight mb-4;
}
.trending-posts-list article.trending .author-avatar {
  @apply h-8 w-8;
}
.trending-posts-list article.trending .author-avatar-parent {
  @apply mr-2;
}
.trending-posts-list article.trending .meta .item {
  @apply mr-1;
}
.right-sidebar .trending-posts-list .trending {
  @apply mb-0;
}
.right-sidebar .trending-posts-list .index {
  @apply mr-2;
}
.right-sidebar .trending-posts-list .trending .author-avatar-parent {
  @apply hidden;
}
.right-sidebar .trending-posts-list .author-name {
  @apply text-xs text-mid-gray;
}
.right-sidebar .trending-posts-list .meta {
  @apply text-mid-gray;
}
.right-sidebar .trending-posts-list .title {
  @apply mb-0 text-sm font-medium;
}
</style>
